import {css, html, LitElement} from 'lit';
import {customElement, property} from 'lit/decorators';
import {normalizeStyles, containerStyles, moduleSpacingStyles} from '@webs/components-library/theming';
@customElement('webs-header-filters')
export class HeaderFilters extends LitElement {

  static styles = [
    moduleSpacingStyles,
    normalizeStyles,
    containerStyles,
    css`
    ::slotted(.hide) { 
      display: none !important;
     }
  
    .tags {
      align-items: center;
      display: flex;
      flex-wrap: wrap;
      margin: 0.6rem 0;
    }
    .tags  a {
      align-items: center;
      background: var(--color-light-grey);
      border-radius: 49.7px;
      color: var(--color-black) !important;
      font-size: .7rem;
      font-family: var(--font-family-alternative);
      font-weight: var(--font-weight-semibold);
      line-height: 1.3;
      padding: .35rem .8rem;
      text-decoration: none;
      cursor: pointer;
      margin: 0 .3rem .5rem;
    }

    .tags .hide {
      display: none !important;
    }

    .tags .action-btn,
    .tags .action-btn-open {
      display: flex;
    }
    
    .tags .action-btn-open::after,
    .tags .action-btn::after {
      background: var(--icon-chevron-down-dark) center/cover no-repeat;
      content: "";
      display: block;
      flex: 0 0 11px;
      height: 7px;
      margin-left: .3rem;
      width: 11px;
    }
    
    .tags .action-btn-open::after {
      transform: rotate(180deg);
    }

    .tags .action-btn-open {
      display: flex;
    }

    .tags .action-btn-open .chevron {
      display: block;
      transform: rotate(180deg);
      
    }
    `
  ]

  @property({attribute: "text-close"})
  textClose = "Show all";

  @property({attribute: "text-open"})
  textOpen = "Hide all";

  protected render(): unknown {
    return html`
    <div class="tags">
        <slot></slot>
      <a class="action-btn" @click="${this.showTags}">${this.textClose}
      </a>
      <a class="action-btn-open hide" @click="${this.hideTags}">${this.textOpen}
      </a>
    </div>
    `
  }
  protected firstUpdated() {
    const items = this.shadowRoot.querySelector('slot').assignedElements();

    for(let i = 0; i < items.length; i++) {
      if(i>3) {
        items[i].classList.add('hide');
      }
    }
  }

  private showTags() {
    const items = this.shadowRoot.querySelector('slot').assignedElements();
    const btn = this.shadowRoot.querySelector('.action-btn');
    const btnOpen = this.shadowRoot.querySelector('.action-btn-open');

    btn.classList.add('hide');
    btnOpen.classList.remove('hide');

    for(let i = 0; i < items.length; i++) {
      if(i>3) {
        items[i].classList.remove('hide');
      }
    }
  }

  private hideTags() {
    const items = this.shadowRoot.querySelector('slot').assignedElements();
    const btn = this.shadowRoot.querySelector('.action-btn');
    const btnOpen = this.shadowRoot.querySelector('.action-btn-open');

    btn.classList.remove('hide');
    btnOpen.classList.add('hide');

    for(let i = 0; i < items.length; i++) {
      if(i>3) {
        items[i].classList.add('hide');
      }
    }
  }
}
